import Card from './card';
import ApiService from '../../../services/apiService';
import functionsService from '../../../services/functionsService';
export default {
  name: 'IsFMDoorCard',
  inheritAttrs: false,
  props: {
    ...Card.props,
    icon: {
      type: String,
      required: true
    },
    subIcon: {
      type: String,
      default: ''
    },
    subIconColor: {
      type: String,
      default: ''
    },
    subTextColor: {
      type: String,
      default: ''
    },
    subText: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    smallValue: {
      type: String,
      default: ''
    },
    button: {
      type: String,
      default: ''
    },
    buttoncolor: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    },
    favUserId: {
      type: String,
      default: ''
    },
    favObjectId: {
      type: Number,
      default: undefined
    },
    favType: {
      type: String,
      default: ''
    },
    accessKeyDates: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loader: null,
      loading: false,
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    };
  },
  computed: {},
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => this[l] = false, 11500);
      this.loader = null;
    }
  },
  methods: {
    processDoor() {
      this.loader = 'loading';
      ApiService.isFmAccessActivateLock({
        id: this.$attrs['isfmaccessid']
      }).then(() => {
        this.$snack(this.$i18n_t('IS.FM.AccessMgmt.doorActivated'), 'success');
      }).catch(error => {
        let userRights = functionsService.userAccessRightHandling(error.response.data.data, this);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(`${userRights} - ${this.$i18n_t('IS.FM.AccessMgmt.doorFailed')}`, 'error');
        }
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    }
  }
};